/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Scope_AllInputs */

const cs_templates_use_picker_scope_all = /** @type {(inputs: Templates_Use_Picker_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celá kancelář`)
};

const en_templates_use_picker_scope_all = /** @type {(inputs: Templates_Use_Picker_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole office`)
};

/**
* | output |
* | --- |
* | "Whole office" |
*
* @param {Templates_Use_Picker_Scope_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_scope_all = /** @type {((inputs?: Templates_Use_Picker_Scope_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Scope_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_scope_all(inputs)
	return cs_templates_use_picker_scope_all(inputs)
});